import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-293f15cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-10 px-12 pt-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-5 pb-3 sm:p-5 text-medium sm:text-xl font-bold" }, " Sign in to your account ", -1))
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "grid grid-cols-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "text-left font-bold text-gray-700"
}, "User *", -1))
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "text-left font-bold text-gray-700"
}, "Password *", -1))
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-red-500"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-8" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "rounded bg-gray-800 px-6 py-2.5 text-xs font-medium uppercase leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-primary-700 hover:shadow-lg focus:bg-primary-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-primary-800 active:shadow-lg",
    "data-te-ripple-init": "",
    "data-te-ripple-color": "dark"
  }, " Sign in ")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "flex items-center bg-red-100 text-red-500 text-md font-bold border-l-4 border-red-500 p-4 mb-4",
  role: "alert"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 mr-4",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.66 9.532l-3.536-.707-.707 3.536 3.536-.707.707-3.536zm2.00    4.602c-6.075 0-11 4.925-11 11h22c0-6.075-4.925-11-11-11zm-8.66 2    .4l2.828 2.829-2.828 2.828 1.414 1.414 2.828-2.828 2.829 2.828 1.414-1.414-2.828-2.828 2.828-2.828-1.414-1.414-2.829     2.828-2.828-2.828-1.414 1.414z" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClipLoader = _resolveComponent("ClipLoader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ClipLoader, {
            key: 0,
            color: _ctx.colorLoading
          }, null, 8, ["color"]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
            method: "post",
            class: "login-form",
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                class: _normalizeClass(["mt-0 block w-full px-0.5 bg-white border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black text-sm mb-5", {
              'border-red-500': _ctx.v.username.$error && _ctx.submitted,
              'border-gray-400': !_ctx.v.username.$error,
            }]),
                placeholder: "User *"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.username,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v.username.$dirty && _ctx.v.username.$error && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Username is required "))
                : _createCommentVNode("", true),
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                class: _normalizeClass(["mt-0 block w-full px-0.5 bg-white border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black text-sm mb-5", {
              'border-red-500': _ctx.v.password.$error && _ctx.submitted,
              'border-gray-400': !_ctx.v.password.$error,
            }]),
                placeholder: "Password *"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.password,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v.password.$dirty && _ctx.v.password.$error && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Password is required "))
                : _createCommentVNode("", true)
            ]),
            _hoisted_9,
            (_ctx.loginError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_ctx.loginError), 1)
                ]))
              : _createCommentVNode("", true)
          ], 32))
    ])
  ]))
}